import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../../../../modules/auth/services/auth.service';
import { InterfaceService } from '../../../../../services/interface.service';
import { AllService } from '../../../../../services/all.service';
import { SenderService } from '../../../../../services/sender.service';
import { finalize, Subject } from 'rxjs';
import { TelegramService } from '../../../telegram.service';
import { ModalService } from '../../../../../services/modal.service';

@Component({
  selector: 'app-sender-arend',
  templateUrl: './sender-arend.component.html',
  styleUrls: ['./sender-arend.component.scss']
})
export class SenderArendComponent implements OnInit {
  @Input() telegramService: TelegramService;
  lastError: any;
  isLoading$: Subject<boolean> = new Subject();
  constructor(
    public modalService: ModalService,
    public authService: AuthService,
    public interfaceService: InterfaceService,
    public allService: AllService,
    public senderService: SenderService,
    public cd: ChangeDetectorRef,
  ) {
  }
  senderArend(): void {
    this.isLoading$.next(true);
    delete this.lastError;
    this.senderService.senderArend({
      account_id: this.senderService.account$.value.id
    }).pipe(finalize(() => {
      this.isLoading$.next(false);
      this.cd.detectChanges();
    })).subscribe(
      (result: any) => {
        this.telegramService.setToken(result.token);
        this.telegramService.setAuth();
        this.telegramService.loadProfile();
      },
      (error) => {
        this.lastError = error;
        // this.telegramService.errorHandling(error);
      }
    );
  }

  showSenderRegister() {
    this.authService.mode$.next('Регистрация');
  }

  arendSenderAccount() {
    if (this.senderService.authTokens?.length > 0) {
      this.senderArend();
    } else {
      this.showSenderRegister();
    }
  }
  ngOnInit(): void {
    if (this.senderService.authTokens?.length > 0) {
      this.authService.mode$.next('Аренда');
    }
  }

}
